export { default } from './ResonateQuizStep';
